import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../client';
import { appKeys } from '../query-keys';
import { useAuthStore } from '@/stores/auth-store';
import { listAppRegistryContract, type ListAppRegistryResponse } from '@bliks-io/contracts';

export function useAppRegistry() {
  const { token } = useAuthStore();

  return useQuery({
    queryKey: appKeys.registry(),
    queryFn: async ({ signal }) => {
      const { data } = await apiClient.get<ListAppRegistryResponse>(listAppRegistryContract.path, {
        signal
      });
      return data.apps;
    },
    enabled: !!token
  });
}
